// extracted by mini-css-extract-plugin
export var htmlPreview = "_ox-2";
export var modal = "_ox-0";
export var sidebar = "_ox-1";